import React, { useEffect, useState } from 'react'
import { checkBoxTheme, textInput } from '../../../theme/flowbite.custom.theme'
import { Checkbox, TextInput } from 'flowbite-react'
import { Skeleton, Typography } from '..'
import propTypes from 'prop-types'
import { useClickOutside } from '../../useOutsideClick'
let timeout = 0
export const MultipleCheckList = ({ options = [], onInputChange = () => null, loading = false, onSelect = () => null, placeholder = "", preSelected = [] }) => {
    const filterRef = React.createRef();
    const [openList, setOpenList] = useState(false)
    const [searchText, setSearchText] = useState("");
    const [optionList, setOptionList] = useState([]);
    const [selectedList, setSelectedList] = useState(preSelected || []);

    const handleChangeSearchField = (e) => {
        setSearchText(e.target.value);
        setOpenList(true);
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            onInputChange(e.target.value)
        }, [500])
    }

    const updateOptions = (options, selectedIds) => (options?.length && options?.map(option => ({
        ...option,
        checked: selectedIds?.includes(option?._id)
    }))) || []

    const handleCheck = (item) => { 
        const checked = !item?.checked;
        const updatedItem = { ...item, checked };
        const updatedList = checked
            ? [...selectedList, updatedItem]
            : selectedList.filter(option => option._id !== item._id);

        const selectedIds = [...updatedList.map(selected => selected._id) || [], ...preSelected || []];
        setSelectedList(updatedList);
        setOptionList(updateOptions(optionList, selectedIds));
        onSelect(updatedList)
    };

    const selectedIds = ((!!selectedList?.length && selectedList?.map(selected => selected?._id))) || [];

    useClickOutside(filterRef, () => setOpenList(false))

    const List = () => (<>
        {!!optionList?.length ? optionList?.map((option, i) =>
            <SingleList key={option?._id} option={option} handleCheck={handleCheck} />)
            : <li className='flex cursor-pointer gap-4 px-2 py-3 items-center h-10 '>
                <Typography variant="base" text={"No Options found"} />
            </li>}
    </>)

    useEffect(() => {
        setOptionList(updateOptions(options, selectedIds))
        return () => {
            clearTimeout(timeout);
        }
        //eslint-disable-next-line 
    }, [options])

    return (
        <div className='relative' ref={filterRef}>
            <TextInput id="filter-menu" type="text" onClick={() => setOpenList(!openList)}
                autoComplete='off' theme={textInput} onChange={handleChangeSearchField} value={searchText}
                placeholder={placeholder || "Search"} sizing={"sm"} name="name" />
            {openList && <div className='absolute top-10 right-0 left-0 bottom-0 z-[1] max-h-64 h-fit w-full overflow-auto
             bg-white border border-secondary-200 rounded-md'>
                <ul>
                    {loading ?
                        [1, 2, 3, 4, 5, 6, 7, 8].map(item => <li key={item} className='my-1'>
                            <Skeleton length={1} className="w-full h-7" />
                        </li>) : <List />
                    }
                </ul>
            </div>}
        </div>
    )
}

const SingleList = ({ option = {}, handleCheck = () => null }) => (<div role="button"
    aria-pressed={String(option?.checked)}
    onClick={() => handleCheck(option)}>
    <li
        className={`flex cursor-pointer gap-4 px-2 py-3 items-center h-10 ${option?.checked ? 'bg-primary-50' : ''}`} >
        <Checkbox color="blue" checked={option?.checked} sizing="lg" onChange={(e) => handleCheck(option)} theme={checkBoxTheme} />
        <Typography variant="base" text={option?.name} />
    </li>
</div>)


SingleList.propTypes = {
    option: propTypes.object,
    handleCheck: propTypes.func
}

MultipleCheckList.propTypes = {
    options: propTypes.array,
    onInputChange: propTypes.array,
    loading: propTypes.bool,
    onSelect: propTypes.func,
    placeholder: propTypes.string
}